<!-- Mobile: Carousel con scroll horizontal -->
<div
  class="-mx-4 flex gap-4 px-4 pt-4 h-auto /* MOBILE (default) */ overflow-x-auto overflow-y-visible snap-x snap-mandatory scroll-smooth scrollbar-hide cursor-grab active:cursor-grabbing /* DESKTOP */ xl:overflow-x-visible xl:overflow-y-visible xl:snap-none xl:scroll-auto xl:cursor-default xl:px-0 xl:mx-0 xl:justify-center xl:items-stretch xl:gap-8"
  style="touch-action: pan-x; -webkit-overflow-scrolling: touch"
>
  <div class="snap-center shrink-0 first:ml-0">
    <app-app-summary-card [apps]="apps"></app-app-summary-card>
  </div>

  <div class="snap-center shrink-0">
    <app-team-density-card
      [frontend]="35"
      [backend]="42"
      [transversal]="12"
      [design]="11"
    ></app-team-density-card>
  </div>

  <div class="snap-center shrink-0 last:mr-4">
    <app-recent-activity-card
      [newUsers]="2"
      [modifiedRoles]="2"
      [newApps]="1"
    ></app-recent-activity-card>
  </div>
</div>
